import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

function ourTechStackSlider() {
  [...document.querySelectorAll('.our-tech-stack__right')]?.forEach( slider => {
    new Splide( slider, {
      type   : 'loop',
      drag   : false,
      focus  : 'left',
      perPage: 5.5,
      autoScroll: {
        speed: 0.25,
        pauseOnHover: true,
        pauseOnFocus: false,
      },
      mediaQuery: 'min',
      breakpoints: {
        782: {
          perPage: 15.5,
        },
      }
    } ).mount({ AutoScroll });
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  ourTechStackSlider();
} );
